// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-tipo-doc[data-v-3c18a8d2]{background-color:#e0e0e0;color:#135f4c;padding:20px;border-radius:5px;font-size:21px;font-weight:500;height:100px;margin:10px;width:350px;display:flex;flex-direction:column;justify-content:center}.box-tipo-doc[data-v-3c18a8d2]:hover{background-color:#b6b6b6}", ""]);
// Exports
module.exports = exports;
